import React, { Component } from "react";
import { Modal, Form, Row, Col, Button } from "antd";
import "./Form.css";

export default class TermosDeUsoForm extends Component {
  state = {

  };


  componentDidUpdate(propsAnterior, stateAnterior) {
    if (this.props.registroSelecionado !== propsAnterior.registroSelecionado) {
      this.setState({
        // registro: this.props.registroSelecionado.data,
        visualizar: this.props.registroSelecionado.visualizar,
      }, () => {
        // this.refs.mar_descricao.focus();
      });
    }
  }





  render() {
    const { onCancelarClick, visivel } = this.props;

    return (
      <Modal
        title={"Contrato de concessão de uso de software"}
        visible={visivel}
        destroyOnClose
        onCancel={onCancelarClick}
        footer={null}
        style={{ top: 30 }}
        width={"60%"}
      >

        <Row>
          <span>
            Pelo presente instrumento e na melhor forma de direito, as partes abaixo qualificadas têm, entre si, justo e acordado, este Contrato de Concessão de Uso de Software que será regido de acordo com as seguintes cláusulas e condições de vontades.
          </span>
          <br />
          <br />
          <span>
            De um lado D J KUS LTDA, com sede na cidade de CAMPO MOURÃO/PR, à Rua Ver. Geremias Cilião Araújo, n. 89, CEP 87.309-086, inscrita no CNPJ/MF sob n. 19.052.746/0001-77 neste ato, representada por seus representantes legais, doravante simplesmente denominada CONTRATADA, e, de outro lado doravante denominado simplesmente CONTRATANTE, tem entre si justo e avençado o seguinte:
          </span>
          <br />
          <br />
          <br />
          <span>
            Cláusula Primeira - do OBJETO
          </span>
          <br />
          <br />
          <span>
            1.1. Por este instrumento particular, a CONTRATADA concede a CONTRATANTE, o uso do programa FASTGESTOR - https://www.fastgestor.com.br, doravante denominado simplesmente SOFTWARE, em forma de código fechado e proprietário, bem como o conteúdo e a estrutura do banco de dados, arquivos de ajuda e qualquer outro de natureza técnica eventualmente fornecidos pela CONTRATADA.
          </span>
          <br />
          <br />
          <span>
            1.2. A CONTRATADA concede a CONTRATANTE o uso do SOFTWARE, unicamente, não constituindo a venda do programa original, dos elementos que o compõem ou de qualquer cópia do mesmo, mas apenas um licenciamento temporário de uso, não exclusivo, mediante contraprestação da mensalidade.
          </span>
          <br />
          <br />
          <span>
            Parágrafo Único: A natureza do presente contrato é a licença de uso do SOFTWARE FASTGESTOR, para uso da CONTRATANTE, sendo a relação norteada pelo ordenamento jurídico em especial pela lei 9.609/98.
          </span>
          <br />
          <br />
          <span>
            1.3. A propriedade do FASTGESTOR não é objeto deste contrato e continua sendo propriedade exclusiva da D J KUS LTDA, sendo que tais direitos estão protegidos pela Legislação Brasileira e Internacional, aplicável a propriedade intelectual e aos direitos autorais, especificamente no Brasil, pela Lei n° 9.609 (Lei do Software) e Lei n° 9.610 (Lei de Direitos Autorais).
          </span>
          <br />
          <br />
          <span>
            Parágrafo Único: Fica expressamente vedado a CONTRATANTE ceder, transferir, conceder, comercializar e licenciar o SOFTWARE FASTGESTOR.
          </span>
          <br />
          <br />
          {/* <span>
            1.4. A CONTRATADA somente certifica Notas Fiscais Eletrônicas no modelo A1, sendo impossível a certificação no modelo A3.
          </span>
          <br />
          <br />
          <span>
            Parágrafo Único - O funcionamento das Notas Fiscais Eletrônicas dependem das Secretarias das Fazendas dos Estados e Municípios Brasileiros. Fica expressamente acordado que ocorrendo falha na comunicação entre a Secretaria da Fazenda do Estado ou Município e o EGestor, este não poderá ser responsabilizado pela falha da comunicação, ficando a CONTRATADA desobrigada por quaisquer danos civil, criminal, tributário e patrimonial.
          </span>
          <br />
          <br />
          <span>
            1.5. O funcionamento das Notas Fiscais Eletrônicas dependem dos Estados e Municípios Brasileiros possuírem o sistema de emissão de Notas Fiscais Eletrônicas.
          </span>
          <br />
          <br /> */}
          <span>
            1.4. A CONTRATADA não realizará personalização ou customização do sistema ao CONTRATANTE, as alterações que ocorrerem no sistema, por deliberalidade da CONTRATADA, será universal e geral.
          </span>
          <br />
          <br />
          <br />
          <span>
            Cláusula Segunda - do PREÇO e das CONDIÇÕES DE PAGAMENTO
          </span>
          <br />
          <br />
          <span>
            2.1. A CONTRATANTE opta pelo plano FASTGESTOR de Testes.
          </span>
          <br />
          <br />
          <span>
            Parágrafo Único: Para optar por algum plano profissional o cliente deverá fazer um novo contrato.
          </span>
          <br />
          <br />
          <br />
          <span>
            Cláusula Terceira - das RESPONSABILIDADES e LIMITAÇÕES
          </span>
          <br />
          <br />
          <span>
            3.1. A CONTRATADA se obriga a manter o SOFTWARE em pleno funcionamento 24 (vinte e quatro) horas por dia e 07 (sete) dias por semana, exceto nas situações de caso fortuito ou força maior.
          </span>
          <br />
          <br />
          <span>
            3.2. A CONTRATADA se obriga a disponibilizar meio para a realização de backup (cópia de segurança) dos bancos de dados das informações adicionadas e mantidas pela CONTRATANTE no SOFTWARE, somente para as versões pagas, que poderá ser executada a qualquer momento pela CONTRATANTE, sendo o conteúdo e a guarda do backup extraído de inteira responsabilidade da CONTRATANTE.
          </span>
          <br />
          <br />
          <span>
            3.2.1. A restauração da cópia de segurança será feita em até 2 (dois) dias após a CONTRATANTE entrar em contato com a CONTRATADA e efetivar a solicitação. A restauração de cópia será gratuita apenas uma única vez ao mês, caso haja a necessidade de ser feita uma ou mais restaurações, será cobrada uma taxa por restauração a qual será informada no momento da solicitação.
          </span>
          <br />
          <br />
          <span>
            3.2.2. No plano gratuíto a restauração da cópia de segurança será realizada após a CONTRATANTE contratar um dos plano pagos, mediante solicitação e condicionado ao disposto na cláusula 3.2.1..
          </span>
          <br />
          <br />
          <span>
            3.2.3. Ocorrendo algum dos casos previstos no ponto 3.4 do presente contrato, em sendo necessárias restaurações, as mesmas serão feitas de forma gratuita, não ocasionando ônus algum a CONTRATANTE.
          </span>
          <br />
          <br />
          <span>
            3.3. A CONTRATADA não se responsabiliza pelo conteúdo das informações contidas no(s) banco(s) de dados do SOFTWARE, sendo este de inteira responsabilidade da CONTRATANTE, inclusive perante terceiros.
          </span>
          <br />
          <br />
          <span>
            3.4. O SOFTWARE poderá ficar indisponível por dificuldades técnicas, falhas de Internet, manutenção improrrogável ou qualquer outra circunstância alheia a vontade da CONTRATADA, as quais não se responsabiliza, tampouco responderá por lucro cessante, bem como qualquer outro tipo de danos diretos e indiretos que surjam em conexão com o presente contrato.
          </span>
          <br />
          <br />
          <span>
            3.5. A CONTRATADA não se responsabiliza por quaisquer insucessos comerciais da CONTRATANTE decorrentes dos serviços aqui prestados, bem como por perdas e danos, lucros cessantes ou qualquer outra indenização, bem como quando decorrente de eventual indisponibilidade dos serviços, quer por ação da CONTRATANTE, quer por terceiros.
          </span>
          <br />
          <br />
          <span>
            3.6. Se as partes deixarem de exigir em qualquer tempo o cumprimento de quaisquer cláusulas ou condições deste contrato, à parte prejudicada não ficará impedida de quando entender, fazer com que a outra parte inadimplente cumpra todas as condições contratuais.
          </span>
          <br />
          <br />
          <span>
            3.7. A eventual tolerância, por uma das partes, a qualquer infração de cláusula ou condição deste contrato, não significará qualquer liberação das obrigações futuras da parte infratora, sem qualquer modificação do dispositivo infringido.
          </span>
          <br />
          <br />
          <span>
            3.8. A CONTRATADA manterá, sob rigoroso sigilo, todos os dados da CONTRATANTE, principalmente aqueles inseridos no SOFTWARE, sob pena de ser responsabilizada civil e criminalmente.
          </span>
          <br />
          <br />
          <span>
            3.9. A CONTRATADA reserva-se no direito de alterar o código-fonte e a sistemática de funcionamento do SOFTWARE sem aviso prévio a CONTRATANTE, desde que não gere prejuízos financeiros.
          </span>
          <br />
          <br />
          <br />
          <span>
            Cláusula Quarta - CONDIÇÕES GERAIS
          </span>
          <br />
          <br />
          <span>
            4.1. A CONTRATANTE não poderá copiar, traduzir, modificar, adaptar, separar, desmontar ou reconstruir o SOFTWARE, bem como o conteúdo e a estrutura do(s) banco(s) de dados.
          </span>
          <br />
          <br />
          <span>
            4.2. Para a utilização do SOFTWARE - FASTGESTOR, por parte da CONTRATANTE, será necessária a utilização mínima dos seguintes equipamentos e programas:
          </span>
          <br />
          <br />
          <span>
            1 - Conexão de banda larga com a Internet de no mínimo 1Mbps (Um Megabyte por segundo);
          </span>
          <br />
          <br />
          <span>
            2 - Pelo menos 01 microcomputador com processador de 800 MHz (Oitocentos Megahertz) ou maior e memória de 512 MB (Quinhentos e doze Megabyte) ou maior;
          </span>
          <br />
          <br />
          <span>
            3 - Navegador Google Chrome na versão atualizada.
          </span>
          <br />
          <br />
          <span>
            Paragrafo Único - O SOFTWARE - FASTGESTOR poderá funcionar em aparelhos celulares e tablets, contudo a CONTRATADA não se responsabiliza pelo não funcionamento e ocorrências de erros.
          </span>
          <br />
          <br />
          <span>
            4.3. O suporte será prestado pela CONTRATADA através dos meio eletrônicos (whatsapp e e-mail) e por telefone, ambos no horário comercial em que esta presta seus serviços.
          </span>
          <br />
          <br />
          <br />
          <span>
            Cláusula Quinta - do PRAZO e da RESCISÃO
          </span>
          <br />
          <br />
          <span>
            5.1. O presente contrato é pactuado pelo prazo determinado de 15 dias.
          </span>
          <br />
          <br />
          <span>
            5.2. Entende-se como solicitação de rescisão contratual a solicitação da parte para migrar do plano gratuito para algum plano pago ou a exclusão dos dados do sistema.
          </span>
          <br />
          <br />
          <span>
            6.1. As partes elegem o foro de Campo Mour~so, estado do Paraná, como único competente para dirimir qualquer controvérsia ou dúvida oriunda do presente contrato, com expressa renúncia a qualquer outro, por mais privilegiado que seja.
          </span>
          <br />
          <br />
          <br />
          <br />
          <br />

        </Row>

        <Row style={{ marginBottom: 20 }}>
          <Col xs={24}>
            <Button
              htmlType="button"
              onClick={onCancelarClick}
              className="btn-fechar"
            >
              Fechar
            </Button>
          </Col>
        </Row>
      </Modal >
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/TermosDeUsoForm.js